module.exports = "<div class=\"form-control-feedback error-msg\" *ngIf=\"displayError\">\r\n  {{errorMsg}}\r\n</div>\r\n"